module.exports = __webpack_public_path__ + "img/dash-square-fill.c5bfd490.svg";